import { render, staticRenderFns } from "./RetencionShowData.vue?vue&type=template&id=dc1bfcb8"
import script from "./RetencionShowData.vue?vue&type=script&lang=js"
export * from "./RetencionShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports